var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurchaseOrder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66662 3.5V17.5H2.33328V21C2.33328 22.9297 3.90362 24.5 5.83328 24.5H20.9999C22.9191 24.5 24.4999 22.9191 24.4999 21V3.5H4.66662ZM6.99995 5.83333H22.1666V21C22.1666 21.6592 21.6591 22.1667 20.9999 22.1667C20.3559 22.1667 19.8333 21.6428 19.8333 21V17.5H6.99995V5.83333ZM9.33328 8.16667V10.5H11.6666V8.16667H9.33328ZM13.9999 8.16667V10.5H19.8333V8.16667H13.9999ZM9.33328 12.8333V15.1667H11.6666V12.8333H9.33328ZM13.9999 12.8333V15.1667H19.8333V12.8333H13.9999ZM4.66662 19.8333H17.4999V21C17.4999 21.4083 17.571 21.8015 17.7005 22.1667H5.83328C5.19045 22.1667 4.66662 21.6428 4.66662 21V19.8333Z",
    fill: "#4D4D4D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseOrder);
export default __webpack_public_path__ + "static/media/purchase_order.ad18ea83688e5c720f9da1f00d1b1afe.svg";
export { ForwardRef as ReactComponent };